<template>
  <el-drawer
    :visible.sync="visible"
    direction="rtl"
    size="400px"
    class="cart-drawer"
    :before-close="handleClose"
  >
    <template slot="title">
      <div class="cart-header">
        <span>{{ $t("app.cartDrawer.title") }}</span>
        <span class="cart-count"
          >({{ cartItemCount }} {{ $t("app.cartDrawer.cartCount") }})</span
        >
      </div>
    </template>

    <div class="cart-content">
      <template v-if="cartItems.length > 0">
        <div class="cart-items">
          <div v-for="item in cartItems" :key="item.id" class="cart-item">
            <img :src="item.image" :alt="item.name" class="item-image" />
            <div class="item-info">
              <h4>{{ item.name }}</h4>
              <div class="item-price">
                <span class="price">${{ item.price }}</span>
                <el-input-number
                  v-model="item.quantity"
                  :min="1"
                  :max="99"
                  size="mini"
                  @change="handleQuantityChange(item)"
                ></el-input-number>
              </div>
            </div>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="removeFromCart(item.id)"
            ></el-button>
          </div>
        </div>

        <div class="cart-footer">
          <div class="cart-total">
            <span>{{ $t("app.cartDrawer.total") }}</span>
            <span class="total-price">${{ totalPrice }}</span>
          </div>
          <el-button
            type="primary"
            class="checkout-btn"
            @click="handleCheckout"
          >
            {{ $t("app.cartDrawer.checkout") }}
          </el-button>
        </div>
      </template>

      <template v-else>
        <div class="empty-cart">
          <!-- <i class="el-icon-shopping-cart-2"></i> -->
          <p>{{ $t("app.cartDrawer.emptyCartMessage") }}</p>
          <el-button type="primary" icon="el-icon-shopping-cart-2" @click="handleClose">
            {{ $t("app.cartDrawer.continueShopping") }}
          </el-button>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "CartDrawer",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      cartItems: (state) => state.cart,
    }),
    ...mapGetters(["cartItemCount", "cartTotal"]),
    totalPrice() {
      return this.cartTotal.toFixed(2);
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
    handleQuantityChange(item) {
      this.$store.dispatch("updateCartItemQuantity", {
        id: item.id,
        quantity: item.quantity,
      });
    },
    removeFromCart(productId) {
      this.$store.dispatch("removeProductFromCart", productId);
      if (this.cartItemCount === 0) {
        this.handleClose();
      }
    },
    handleCheckout() {
      // TODO: 实现结算功能
      this.$message({
        message: this.$t('app.cartDrawer.checkoutInDevelopment'),
        type: "info",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cart-drawer {
  .cart-header {
    padding: 20px;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
    }
  }

  .cart-content {
    padding: 20px;
    height: calc(100vh - 200px);
    overflow-y: auto;

    .empty-cart {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 0;

      img {
        width: 120px;
        margin-bottom: 20px;
      }

      p {
        color: var(--text-regular);
        margin-bottom: 20px;
      }
    }

    .cart-item {
      display: flex;
      padding: 15px 0;
      border-bottom: 1px solid var(--border-color);

      &:last-child {
        border-bottom: none;
      }

      .item-image {
        width: 80px;
        height: 80px;
        margin-right: 15px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .item-info {
        flex: 1;

        .item-name {
          font-size: 16px;
          margin-bottom: 5px;
        }

        .item-price {
          color: var(--primary-color);
          font-weight: bold;
          margin-bottom: 10px;
        }

        .item-actions {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .quantity-control {
            display: flex;
            align-items: center;

            .el-input-number {
              width: 120px;
            }
          }

          .remove-btn {
            color: var(--danger-color);
            cursor: pointer;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }

  .cart-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    border-top: 1px solid var(--border-color);
    background-color: #fff;

    .total {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .total-label {
        font-size: 16px;
      }

      .total-amount {
        font-size: 20px;
        font-weight: bold;
        color: var(--primary-color);
      }
    }

    .checkout-btn {
      width: 100%;
    }
  }
}
</style> 
